module.exports = __webpack_public_path__ + "img/unpublish.538f882e.svg";